module.exports = __webpack_public_path__ + "media/app-icon-580eadd3.jpg";